var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { default as React } from 'react';
import { RadioGroupControl } from '../RadioGroupControl';
import { AutosaveField } from './AutosaveField';
export var AutosaveRadioGroup = function (props) { return (React.createElement(AutosaveField, { field: props.field, render: function (field) {
        // Happy to leave the onChange of AutosaveRadioGroup just using value
        // rather than adjust more of the existing application.
        function onChange(event, value) {
            field.onChange(value);
            if (props.onChange)
                props.onChange(value);
        }
        return (React.createElement(RadioGroupControl, __assign({}, props, { required: props.required, errorText: props.errorText, readOnly: props.readOnly, value: field.fieldValue, onChange: onChange })));
    } })); };
